/**
 * Jackpot Replacer Model
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var $ = require('j');
    var BaseModel = require('common/base.model');
    var core = require('core');
    var user = require('user');
    var config = require('config');
    var server = require('server');

    module.exports = BaseModel.extend({
        initialize: function() {
            this.status = {};
        },

        subscribe: function() {
            this.listenTo(user, 'change:currencyCode change:country', this.fetch.bind(this, null));
            this.listenTo(core, 'app:initialResourcesLoaded', this.initialResourcesLoaded);
        },

        initialResourcesLoaded: function() {
            this.getVfJackpots = config.get('useServicesVfJackpots');
            this.getCasinoJackpots = config.get('useServicesCasinoJackpots');

            // jackpots now being fetched in React
            // this.fetch();
        },

         // jackpots now being fetched in React
        sync: function() {},

        parse: function(data) {
            var response;

            if (data instanceof Array) {
                if (this.getCasinoJackpots && this.getVfJackpots) {
                    response = _.extend({},
                        this.oldParse(data[0]),
                        this.newParse(data[1])
                    );
                } else if (this.getCasinoJackpots) {
                    response = this.newParse(data[0]);
                } else {
                    response = this.oldParse(data[0]);
                }

                return {
                    jackpots: response,
                    totals: this.parseTotalJackpots(data),
                    raw: this.reactParse(data)
                };
            }
        },

        parseTotalJackpots: function(data) {
            var jackpotData = this.getCasinoJackpots && this.getVfJackpots ? data[1] : data[0];

            return jackpotData && jackpotData.casinodata && jackpotData.casinodata.amountList.amount || [];
        },

        oldParse: function(data) {
            if (data.jackpots) {
                return _.chain(data.jackpots)
                    .map(this._parseImsResponse.bind(this))
                    .groupBy('gameCode')
                    .value();
            }

            return data;
        },

        newParse: function(data) {
            data = data && data.gamedata || null;

            if (data instanceof Array) {
                return data.reduce(this._parseNewImsResponse.bind(this), {});
            }

            return {};
        },

        reactParse: function(data) {
            var result = {};

            if (data instanceof Array) {
                if (this.getCasinoJackpots && this.getVfJackpots) {
                    result.vfJackpots = data[0];
                    result.casinoJackpots = data[1];
                } else if (this.getCasinoJackpots) {
                    result.casinoJackpots = data[0];
                } else {
                    result.vfJackpots = data[0];
                }
            }

            return result;
        },

        _parseNewImsResponse: function(result, jackpot) {
            var amount = jackpot.amountList.amount[0];
            var game = jackpot.game;
            var jackpotAmount = amount.jackpotAmount;
            var step = amount.step;
            var hitTime = amount.guaranteedHitTime;

            result[game] = [this.createJackpot(game, jackpotAmount, step, hitTime)];

            return result;
        },

        _parseImsResponse: function(jackpot) {
            var code = jackpot.jackpotName;
            var amount = jackpot.jackpotAmount;
            var step = jackpot.Step;

            return this.createJackpot(code, amount, step);
        },

        createJackpot: function(code, amount, step, hitTime) {
            step = Number(step);

            return {
                gameCode: code,
                currencyCode: window.Playtech.API.formatter.getCurrencySymbol(),
                interval: 100,
                step: step || 0.01,
                amount: amount * 0.99, // 99% from amount
                originAmount: amount,
                guaranteedHitTime: hitTime
            };
        },

        clear: function() {
            this.status = {};
            return BaseModel.prototype.clear.apply(this, arguments);
        },

        _imsRequest: function() {
            var bingoRegion = this._getBingoRegion();
            var cacheToken = this._getCacheToken(bingoRegion);
            var cachedJackpot = this.status[cacheToken];
            var requests = [];
            var dfd = $.Deferred();

            if (cachedJackpot) {
                return cachedJackpot;
            }

            this.getVfJackpots && requests.push(this.vfRequest(bingoRegion));
            this.getCasinoJackpots && requests.push(this._newImsRequest());

            if (!requests.length) {
                dfd.reject();
            } else {
                $.when(requests)
                    .done(function() {
                        var result = [].map.call(arguments, function(arr) {
                            return arr.data;
                        });
                        dfd.resolve(result);
                    })
                    .fail(dfd.reject);

                this.status[cacheToken] = dfd;
            }

            return dfd;
        },

        vfRequest: function(bingoRegion) {
            return server.send({
                ID: 81704,
                description: 'Get Bingo Jackpots',
                responses: [81705, 81706],
                casino: config.get('casinoName'),
                region: bingoRegion,
                uniqueJackpots: true,
                version: '1.7'
            });
        },

        _newImsRequest: function() {
            return server.send({
                ID: 35213,
                description: 'Get jackpots',
                casino: config.get('jackpotsCasino'),
                currency: user.get('currencyCode'),
                responses: [35214, 35215]
            });
        },

        _getBingoRegion: function() {
            var country = user.get('country');
            var currencyCode = user.get('currencyCode');
            var locations = config.get('locationJson.items');
            var regionItem = _.findWhere(locations, {
                currency: currencyCode,
                countryCode: country
            });
            return regionItem && regionItem.region || config.get('defaultBingoRegion');
        },

        _getCacheToken: function(bingoRegion) {
            var token = 'currency:' + user.get('currencyCode');
            if (bingoRegion) {
                token += '_bingo:' + bingoRegion;
            }
            return token;
        },

        updateJackpots: function(jackpotsData) {
            const currentJackpots = this.toJSON();
            const { jackpots, totals, raw } = this.parse(jackpotsData);

            this.set({
                jackpots: { ...currentJackpots.jackpots, ...jackpots },
                totals: { ...currentJackpots.totals, ...totals },
                raw: { ...currentJackpots.raw, ...raw }
            });
        }
    });
});
